"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const react_1 = __importStar(require("react"));
const react_final_form_1 = require("react-final-form");
const FormContexts_1 = require("../Contexts/FormContexts");
const types_1 = require("../types");
const defaultValidationState = { errors: [], warnings: [], options: undefined };
// Those subscriptions are necessary until mobile supports onFocus and onBlur events
const subscription = {
    value: true,
    touched: true,
    modified: true,
    visited: true,
};
/**
 *  This component is used to wrap the given control in the final form Field component
 * @param controlPath The defined path of this control, as determined by final-form
 * @param controlDefinition The definition of this control. This is primarily used to determing whether the field should be read only
 * @param validationFn The validation function used to validate the warnings and errors of this control
 * @param render The render prop which is used to render the control. This is passed a set of props used to render the form control passed by the consuming application
 */
const FieldRender = props => {
    const { controlPath, validationFn, render, controlDefinition } = props;
    const readOnlyMode = react_1.default.useContext(FormContexts_1.FormReadOnlyContext);
    const { updateControlPathLocalFieldWarning, fieldValidationWarnings } = (0, FormContexts_1.useFieldValidation)();
    const [firstRun, setFirstRun] = (0, react_1.useState)(!validationFn);
    const [validationState, setValidationState] = (0, react_1.useState)(defaultValidationState);
    const validate = (0, react_1.useCallback)(async (value, allValues) => {
        if (validationFn) {
            const { errors, warnings, options } = await validationFn(value, allValues, undefined, controlPath);
            if (!firstRun)
                setFirstRun(true);
            if (!(0, lodash_isequal_1.default)(errors, validationState.errors) || !(0, lodash_isequal_1.default)(warnings, validationState.warnings) || !(0, lodash_isequal_1.default)(options, validationState.options)) {
                setValidationState({ errors, warnings, options });
            }
            return errors && errors.length ? errors[0] : undefined;
        }
    }, [validationFn, validationState, controlPath, firstRun]);
    const localRender = (0, react_1.useCallback)(({ input, meta }) => {
        var _a;
        // we may want to add the entire meta to fields
        // the touch becomes true when the user click submit.
        const touched = meta.touched || meta.modified || meta.visited;
        // const isSelectorControlType = ['barcode', 'location', 'mapAggregateSelector', 'polyline', 'select', 'radio', 'checkbox'].includes(
        //   controlDefinition.type
        // );
        const _b = touched
            // meta.touched || (isSelectorControlType && meta.modified)
            ? validationState
            : lodash_1.default.cloneDeep(defaultValidationState), { options } = _b, validationProps = __rest(_b, ["options"]);
        // warnings are visible after the field is "modified" or "visited" (touched behaves like "submited")
        // validationProps.warnings = meta.modified || meta.visited ? validationState.warnings : [];
        if (((_a = validationProps.warnings) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            updateControlPathLocalFieldWarning(controlPath, validationState.warnings);
        }
        else {
            if (fieldValidationWarnings) {
                delete fieldValidationWarnings[controlPath];
            }
        }
        const more = validationState.options ? { options: validationState.options } : {};
        return render(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, validationProps), { validationFn }), input), more), { pending: !firstRun, touched: meta.touched, readOnly: readOnlyMode || ((0, types_1.isV2EditableComponent)(controlDefinition) && controlDefinition.readOnly) }));
        //return <Component {...props} {...validationProps} {...input} touched={meta.touched} />;
    }, [
        controlDefinition,
        readOnlyMode,
        render,
        validationState,
        validationFn,
        controlPath,
        fieldValidationWarnings,
        updateControlPathLocalFieldWarning,
        firstRun,
    ]);
    /*
      This is how final form assumes this will be done, which requires slightly different implementation on the frontend
      const type =
      controlDefinition.type === 'group' || controlDefinition.type === 'radio' ? controlDefinition.type : undefined;*/
    return (react_1.default.createElement(react_final_form_1.Field, { subscription: subscription, name: controlPath, validate: validationFn ? validate : undefined, render: localRender }));
};
exports.default = FieldRender;
